import z from "zod";

export const Settings = z.object({
  maxInputTokensPerMonth: z.number(),
  maxOutputTokensPerMonth: z.number()
});

export type Settings = z.infer<typeof Settings>;